/* global axios */
import ApiClient from '../ApiClient';

class ElectoralCampaignMediaAssetsAPI extends ApiClient {
  constructor() {
    super('electoral_campaign/media_assets', {
      accountScoped: true,
      apiVersion: 'v2',
    });
  }

  list({ kanbanStatus, assetType, platform } = {}) {
    const params = {};
    if (kanbanStatus) params.kanbanStatus = kanbanStatus;
    if (assetType) params.assetType = assetType;
    if (platform) params.platform = platform;
    return axios.get(this.url, { params });
  }

  create(payload, files = []) {
    const fd = new FormData();
    Object.entries(payload).forEach(([k, v]) => {
      if (Array.isArray(v)) v.forEach(x => fd.append(`${k}[]`, x));
      else if (v !== null && v !== undefined) fd.append(k, v);
    });
    files.forEach(f => fd.append('files[]', f));
    return axios.post(this.url, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  update(id, payload, files = []) {
    const fd = new FormData();
    Object.entries(payload).forEach(([k, v]) => {
      if (Array.isArray(v)) v.forEach(x => fd.append(`${k}[]`, x));
      else if (v !== null && v !== undefined) fd.append(k, v);
    });
    files.forEach(f => fd.append('files[]', f));
    return axios.patch(`${this.url}/${id}`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  updateStatus(id, kanbanStatus) {
    return axios.patch(`${this.url}/${id}`, { kanbanStatus });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new ElectoralCampaignMediaAssetsAPI();
